import Image from "next/image"

import { Box } from "components/shared/box"
import { ClippedBox } from "components/shared/clipped-box/clipped-box"
import { ClippedCard } from "components/shared/landing/clipped-card"
import { Section } from "components/shared/landing/section"
import { Text } from "components/shared/text"

import spaceshipsBattleImg from "/public/images/pages/index/ships-section/spaceships-battle.webp"

export function ShipsSection() {
  return (
    <Section>
      <ClippedCard row full className="flex-col items-center md:justify-between md:flex-row">
        <Box center className="flex-1">
          <Box className="flex-1 max-w-[550px] mx-auto w-full">
            <ClippedBox corners={{ rt: true, lb: true }} className="rounded-lg overflow-hidden">
              <Image src={spaceshipsBattleImg} alt="robot image" />
            </ClippedBox>
          </Box>
        </Box>
        <Box className="flex-1 justify-center md:ml-4 mt-4 md:mt-0">
          <Text as="h2" className="text-center md:text-left">
            Spaceships Battles
          </Text>
          <p className="text-base text-white text-center opacity-80 mt-4 md:mt-6 md:text-left">
            Take battles to the cosmic level! Manufacture a fleet of ships that will take your Bots to the deeper space
            to travel or join massive battles!
          </p>
        </Box>
      </ClippedCard>
    </Section>
  )
}
